// @ts-expect-error markdown-truncate is not written in typescript
import truncateMarkdown from 'markdown-truncate';

/**
 * Truncates a string to a maximum length, adding an ellipsis if the string is longer than the maximum length.
 * Example usage:
 *
 * ellipsifyString('very_longg_file_name_bla_bla_bla.txt', 10)
 *
 * Output: `very_longg...`
 * @returns
 */
export function ellipsifyMarkdown(str: string, maxLength: number): string {
    return truncateMarkdown(str, { limit: maxLength, ellipsis: true });
}
export function ellipsifyString(str: string, maxLength: number): string {
    return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
}

export function capitalizeFirstLetter(string: string): string {
    if (string.length === 0) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Input: 'TestString'
 * Output: 'testString'
 *
 * Input: 'testString'
 * Output: 'testString' (stays unchanged)
 * @param string
 * @returns
 */
export function lowercaseFirstLetter(string: string): string {
    if (string.length === 0) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}
